import { useContactType } from "../../../contexts/ContactContext";
import { useVendorType } from "../../../contexts/VendorContext";
import { Col, Text, VImage } from "../../../style/base.style";
import { Colors, letterColors } from "../../../style/colors";

interface ProfileImgProps {
    width: number;
    height: number;
    contact?: Contact | FamilyMember| null;
    borderRadius?: string;
}

function letterToNumeric(name:string) {
  const letter = name?.charAt(0).toUpperCase();
  if (!letter || typeof letter !== "string") return null; // Ensure valid input
  
  let position = 1
  const unicodeValue = letter.charCodeAt(0);

  // Check if the letter is English (A-Z)
  if (unicodeValue >= 65 && unicodeValue <= 90) {
      position = unicodeValue - 64; // A = 1, B = 2, ..., Z = 26
  }

  // Check if the letter is Hebrew (א-ת, Unicode 1488-1514)
  if (unicodeValue >= 1488 && unicodeValue <= 1514) {
      position = unicodeValue - 1487; // א = 1, ב = 2, ..., ת = 22
  }

  return letterColors[position]; // Not an English or Hebrew letter
}


export const ProfileImg = ({width,height,contact,borderRadius}:ProfileImgProps) => {
  const accountType = useContactType();
  const {vendor} = useVendorType();
  contact = contact || accountType.contact ;


  if(!contact && !vendor) return null;
  console.log(contact?.Record_Image,"Record_Image")
  if(contact?.Record_Image){
    return (
        <Col $width={`${width}px`} $height={`${height}px`} $borderRadius={borderRadius || "50%"}>
        <VImage
          src={process.env.REACT_APP_API_ENDPOINT + `/public-images/${contact.id}`}
          alt="User Image"
          $borderRadius={borderRadius || "50%"}
        />
        
        </Col>
      
    )
  }
  if(contact){
  return (
      <Col $width={`${width}px`} $height={`${height}px`} $borderRadius={borderRadius || "50%"} $backgroundColor={letterToNumeric(contact.Full_Name)} $justifyContent="center" $alignItems="center">   
        <Text $color={Colors.whiteBackground} $margin="0" $fontWeight={600} $fontSize={`${width*0.5}px`}>{contact.Full_Name.charAt(0).toUpperCase()}</Text>
      </Col>
    )
    }



      if(vendor?.Record_Image){
    return (
        <Col $width={`${width}px`} $height={`${height}px`} $borderRadius={borderRadius || "50%"}>
        <VImage
          src={process.env.REACT_APP_API_ENDPOINT + `/vendor-images/${vendor.id}`}
          alt="User Image"
          $borderRadius={borderRadius || "50%"}
        />
        
        </Col>
      
    )
  }
   const vendorName = vendor?.Vendor_Name || "V";
  return (
      <Col $width={`${width}px`} $height={`${height}px`} $borderRadius={borderRadius || "50%"} $backgroundColor={letterToNumeric(vendorName)} $justifyContent="center" $alignItems="center">   
        <Text $color={Colors.whiteBackground} $margin="0" $fontWeight={600} $fontSize={`${width*0.5}px`}>{vendor?.Vendor_Name.charAt(0).toUpperCase()}</Text>
      </Col>
    )

}